import Member from '@/models/Member'

class ctiWindow {
  static windowConfigGenerate (object) {
    const string = []

    for (const i in object) {
      string.push(`${i}=${object[i]}`)
    }

    return string.join(', ')
  }

  static centerPopUpPosition (width, height) {
    const top = (window.top.outerHeight / 2) + window.top.screenY - (height / 2)
    const left = (window.top.outerWidth / 2) + window.top.screenX - (width / 2)

    return this.windowConfigGenerate({ width, height, top, left })
  }

  static outboundWindow (params) {
    let parameters = ''
    if (params.callback_id) {
      parameters += `?callback_id=${  params.callback_id}`
    }
    const windowConfig = this.centerPopUpPosition(920, 600)
    window.open(`/window/outbound/${  params.id  }${parameters}`, '', windowConfig)
  }

  static outboundSelectMemberWindow (params) {
    let parameters = ''
    if (params.callback_id) {
      parameters += `?callback_id=${ params.callback_id}&phone_number=${ params.phone_number}`
    }
    const windowConfig = this.centerPopUpPosition(920, 600)
    window.open(`/window/outbound/select-members${parameters}`, '', windowConfig)
  }

  static editConsultationWindow (params) {
    const windowConfig = this.centerPopUpPosition(920, 600)
    window.open(`/window/outbound/${  params.id  }/edit-consultation/${  params.consultationId}`, '', windowConfig)
  }

  static viewConsultationWindow (params) {
    const windowConfig = this.centerPopUpPosition(920, 370)
    window.open(`/window/outbound/${  params.id  }/view-consultation/${  params.consultationId}`, '', windowConfig)
  }

  static editOutboundWindow (params) {
    const windowConfig = this.centerPopUpPosition(920, 600)
    window.open(`/window/outbound/${  params.id  }/consultation/${  params.consultationId}`, '', windowConfig)
  }

  static async inboundWindow (obj) {

    Number.prototype.pad = function (len) {
      return (new Array(len + 1).join('0') + this).slice(-len)
    }
    const windowConfig  = this.centerPopUpPosition(980, 740)
    const pathname      = window.location.href
    const currentDate   = new Date()

    const hours         = currentDate.getHours().pad(2)
    const minutes       = currentDate.getMinutes().pad(2)
    const seconds       = currentDate.getSeconds().pad(2)

    const time_now      = `${hours}:${minutes}:${seconds}`
    const title         = `전화 인입 시간 - ${time_now}`
    const modal         = obj.cid.replace('.', '') + obj.extension + obj.agi_arg_5 + obj.agi_arg_4
    const modal_id      = modal.replace(/[^\w\s]/gi, '')
    let params = []

    let memberCount = 0

    if (obj.cid) {
      params.push(`phone_no=${obj.cid}`)

      const response = await Member.findMemberByPhoneNumber(obj.cid)
      memberCount = response.data.memberCount
    }

    if (obj.extension) {
      params.push(`ext_no=${obj.extension}`)
    }

    if (obj.agi_arg_3) {
      params.push(`ring_gr=${obj.agi_arg_3}`)
    }

    if (obj.agi_arg_4) {
      params.push(`uniqueid=${obj.agi_arg_4}`)
    }

    if (obj.agi_arg_5) {
      params.push(`chanel=${obj.agi_arg_5}`)
    }

    if (obj.agi_arg_7) {
      params.push(`ivr_number=${obj.agi_arg_7}`)
    }

    if (obj.agi_arg_8) {
      params.push(`recordingfile=${obj.agi_arg_8}`)
    }

    params.push(`server=${encodeURIComponent(pathname)}`)
    params.push(`modal_id=${modal_id}`)
    params.push(`title=${title}`)

    params = params.join('&', params)
    if (memberCount > 1) {
      window.open(`/window/inbound/select-member?${params}`, '', windowConfig)
    } else {
      window.open(`/window/inbound?${params}`, '', windowConfig)
    }

  }

  static queueStatusWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 740)
    window.open(`/window/queue-status?queue=${queueNumber}`, '', windowConfig)
  }
  static queueStatusCdrWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 740)
    window.open(`/window/queue-status-cdr?queue=${queueNumber}`, '', windowConfig)
  }

  static obQueueStatusWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 740)
    window.open(`/window/queue-status/v2?queue=${queueNumber}`, '', windowConfig)
  }
  static obQueueStatusCdrWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 740)
    window.open(`/window/queue-status-cdr/v2?queue=${queueNumber}`, '', windowConfig)
  }

  static editQueueStatusLabelWindow (params) {
    const windowConfig = this.centerPopUpPosition(500, 150)
    window.open(`/window/queue-status/label/edit/${params.id}`, '', windowConfig)
  }

  static queueReportStatusWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 760)
    window.open(`/window/queue-status-report?queue=${queueNumber}`, '', windowConfig)
  }

  static queueReportStatusCdrWindow (queueNumber) {
    const windowConfig = this.centerPopUpPosition(1280, 760)
    window.open(`/window/queue-status-report-cdr?queue=${queueNumber}`, '', windowConfig)
  }

  static consultationRecordingFile (src, uniqueId, type = 'inbound') {
    let params = `?unique_id=${uniqueId}&src=${src}`
    if (type === 'outbound') {
      params = `?unique_id=${uniqueId}&dst=${src}`
    }
    const windowConfig = this.centerPopUpPosition(465, 80)
    window.open(`/window/consultation-recording-file${params}`, '', windowConfig)
  }
  static consultationOneTouchRecordingFile (src, uniqueId, type = 'inbound') {
    let params = `?unique_id=${uniqueId}&src=${src}`
    if (type === 'outbound') {
      params = `?unique_id=${uniqueId}&dst=${src}`
    }
    const windowConfig = this.centerPopUpPosition(465, 80)
    window.open(`/window/consultation-one-touch-recording-file${params}`, '', windowConfig)
  }

  static addMemberWindow () {
    const windowConfig = this.centerPopUpPosition(800, 700)
    window.open('/window/member/add', '', windowConfig)
  }

  static outboundHistoryWindow (params) {
    const windowConfig = this.centerPopUpPosition(1200, 770)
    window.open(`/window/member/outbound/history/${  params.id}`, '', windowConfig)
  }
  static outboundCompanyListWindow (params) {
    const windowConfig = this.centerPopUpPosition(1450, 600)
    window.open(`/window/member/outbound/list/${  params.company_name}`, '', windowConfig)
  }
  static addAnnouncementWindow () {
    const windowConfig = this.centerPopUpPosition(800, 610)
    window.open('/window/announcement/add', '', windowConfig)
  }
  static openEditAnnouncementWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 650)
    window.open(`/window/announcement/edit/${  params.id}`, '', windowConfig)
  }
  static viewAnnouncementWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open(`/window/view-announcement/${  params.id}`, '', windowConfig)
  }
  static addConsultationCustomFieldWindow () {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open('/window/consultation/add-custom-field', '', windowConfig)
  }
  static editConsultationCustomFieldWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open(`/window/consultation/edit-custom-field/${  params.id}`, '', windowConfig)
  }
  static addUserWindow () {
    const windowConfig = this.centerPopUpPosition(800, 650)
    window.open('/window/user/add', '', windowConfig)
  }
  static editUserPermissionWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open(`/window/user/edit-permission/${  params.id}`, '', windowConfig)
  }
  static addProjectWindow () {
    const windowConfig = this.centerPopUpPosition(800, 450)
    window.open('/window/project/add', '', windowConfig)
  }
  static addBlacklistWindow () {
    const windowConfig = this.centerPopUpPosition(800, 450)
    window.open('/window/blacklist/add', '', windowConfig)
  }
  static editProjectWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 450)
    window.open(`/window/project/edit/${  params.id}`, '', windowConfig)
  }
  static addTaskWindow () {
    const windowConfig = this.centerPopUpPosition(800, 700)
    window.open('/window/task/add', '', windowConfig)
  }
  static editTaskWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 700)
    window.open(`/window/task/edit/${  params.id}`, '', windowConfig)
  }
  static editTaskProgressWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open(`/window/task/edit-progress/${  params.id}`, '', windowConfig)
  }
  static viewTaskWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 600)
    window.open(`/window/view-task/${  params.id}`, '', windowConfig)
  }
  static viewScheduleWindow (params) {
    const windowConfig = this.centerPopUpPosition(600, 400)
    window.open(`/window/view-schedule/${params.id}`, '', windowConfig)
  }
  static addMessageTemplateWindow () {
    const windowConfig = this.centerPopUpPosition(800, 550)
    window.open('/window/add-message-template', '', windowConfig)
  }
  static editMessageTemplateWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 550)
    window.open(`/window/edit-message-template/${  params.id}`, '', windowConfig)
  }
  static openSendSMSWindow (params) {
    const windowConfig = this.centerPopUpPosition(1200, 800)
    window.open(`/window/send-sms/${  params.number}`, '', windowConfig)
  }
  static openEditCallbackNumberWindow (params) {
    const windowConfig = this.centerPopUpPosition(600, 220)
    window.open(`/window/messages/edit-callback/${  params.id}`, '', windowConfig)
  }
  static addMessageCategoryWindow () {
    const windowConfig = this.centerPopUpPosition(800, 300)
    window.open('/window/messages/category/add', '', windowConfig)
  }
  static openEditTimeConditionWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 800)
    window.open(`/window/time-condition/edit/${  params.id}/${  params.keyword}/${  params.type}`, '', windowConfig)
  }
  static openAddTimeConditionWindow (params) {
    const windowConfig = this.centerPopUpPosition(600, 800)
    window.open(`/window/time-condition/add/${  params.keyword}/${  params.type}`, '', windowConfig)
  }
  static openEditTransferWindow (params) {
    const windowConfig = this.centerPopUpPosition(800, 300)
    window.open(`/window/transfer/edit/${  params.id}`, '', windowConfig)
  }
  static openTransfersHistorWindow () {
    const windowConfig = this.centerPopUpPosition(1200, 770)
    window.open('/window/transfer/history', '', windowConfig)
  }
  static openSendMessageWindow () {
    const windowConfig = this.centerPopUpPosition(700, 260)
    window.open('/window/send-message', '', windowConfig)
  }
  static openOutboundPopupWindow (params) {
    const windowConfig = this.centerPopUpPosition(750, 560)
    if (typeof params !== 'undefined' && typeof params.phoneNumber !== 'undefined') {
      window.open(`/window/outbound-popup/${params.phoneNumber}`, '', windowConfig)
    } else {
      window.open('/window/outbound-popup', '', windowConfig)
    }
  }
  static openUpdateSchedulePopupWindow (params) {
    const windowConfig = this.centerPopUpPosition(1100, 700)
    window.open(`/window/schedules/${params.date}`, '', windowConfig)
  }
  static openUploadSoundFileWindow () {
    const windowConfig = this.centerPopUpPosition(600, 250)
    window.open('/window/upload-sound-file', '', windowConfig)
  }
  static openSoundFileWindow (extension) {
    const windowConfig = this.centerPopUpPosition(700, 620)
    window.open(`/window/sound-files/${extension}`, '', windowConfig)
  }
  static openUploadAutoCallSystemPublicDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 200)
    window.open('/window/auto-call-system/public/upload', '', windowConfig)
  }
  static openExportAutoCallSystemPublicDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 500)
    window.open('/window/auto-call-system/public/export', '', windowConfig)
  }
  static openDeleteAutoCallSystemPublicDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 380)
    window.open('/window/auto-call-system/public/delete', '', windowConfig)
  }
  static openUploadAutoCallSystemDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 200)
    window.open('/window/auto-call-system/upload', '', windowConfig)
  }
  static openExportAutoCallSystemDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 500)
    window.open('/window/auto-call-system/export', '', windowConfig)
  }
  static openDeleteAutoCallSystemDataWindow () {
    const windowConfig = this.centerPopUpPosition(600, 380)
    window.open('/window/auto-call-system/delete', '', windowConfig)
  }
  static openEditCallerIdWindow (params) {
    const windowConfig = this.centerPopUpPosition(600, 500)
    window.open(`/window/caller-id/${params.caller_id}/users`, '', windowConfig)
  }
  static openCallNoteWindow (path) {
    const windowConfig = this.centerPopUpPosition(552, 750)
    window.open(`/window/call-note?url=${path}`, '', windowConfig)
  }
  static openEditCompanyWorktimeWindow () {
    const windowConfig = this.centerPopUpPosition(550, 260)
    window.open('/window/company/worktime/edit', '', windowConfig)
  }
  static openViewExtensionStatusDataAnalysisPopupWindow (params) {
    const windowConfig = this.centerPopUpPosition(1000, 600)
    window.open(`/window/view-extension-status-data-analysis/${params.ext}?date=${params.date}`, '', windowConfig)
  }
  static openTimeConditionSoundFileWindow (index, list) {
    const windowConfig = this.centerPopUpPosition(630, 200)
    window.open(`/window/time-conditions/sound-file/${index}/${list}`, '', windowConfig)
  }
  static openModifyQueueWindow (index, list) {
    const windowConfig = this.centerPopUpPosition(630, 600)
    window.open('/window/modify-queue', '', windowConfig)
  }
  static queueHistoryWindow (params) {
    const windowConfig = this.centerPopUpPosition(1100, 700)
    window.open(`/window/queue-cdr-history?date=${params.date}&queue_number=${params.queue_number}&time=${params.time}`, '', windowConfig)
  }
}

export default ctiWindow
